import * as React from "react"
import ContactForm from "@/components/contact-form"
import usePopup from "@/hooks/usePopup"
import { IPropsInner } from "@/components/contact-form/ContactForm"

export default function useContactForm(
  location?: ILocation,
  props?: IPropsInner
) {
  const [isOpen, handleOpen, handleClose] = usePopup()
  const dom = (
    <ContactForm
      isOpen={isOpen}
      handleOpen={handleOpen}
      handleClose={handleClose}
      location={location}
      props={props}
    />
  )
  return { dom, isOpen, handleOpen, handleClose }
}
